import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { get } from 'lodash';
/**
 * WordPress dependencies
 */

import { useCallback, useMemo } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { applyFormat, removeFormat, getActiveFormat, useAnchorRef } from '@wordpress/rich-text';
import { ColorPalette, URLPopover, getColorClassName, getColorObjectByColorValue, getColorObjectByAttributeValues } from '@wordpress/block-editor';
/**
 * Internal dependencies
 */

import { textColor as settings } from './index';
export function getActiveColor(formatName, formatValue, colors) {
  var activeColorFormat = getActiveFormat(formatValue, formatName);

  if (!activeColorFormat) {
    return;
  }

  var styleColor = activeColorFormat.attributes.style;

  if (styleColor) {
    return styleColor.replace(new RegExp("^color:\\s*"), '');
  }

  var currentClass = activeColorFormat.attributes.class;

  if (currentClass) {
    var colorSlug = currentClass.replace(/.*has-([^\s]*)-color.*/, '$1');
    return getColorObjectByAttributeValues(colors, colorSlug).color;
  }
}

var ColorPicker = function ColorPicker(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange;
  var colors = useSelect(function (select) {
    var _select = select('core/block-editor'),
        getSettings = _select.getSettings;

    return get(getSettings(), ['colors'], []);
  });
  var onColorChange = useCallback(function (color) {
    if (color) {
      var colorObject = getColorObjectByColorValue(colors, color);
      onChange(applyFormat(value, {
        type: name,
        attributes: colorObject ? {
          class: getColorClassName('color', colorObject.slug)
        } : {
          style: "color:".concat(color)
        }
      }));
    } else {
      onChange(removeFormat(value, name));
    }
  }, [colors, onChange]);
  var activeColor = useMemo(function () {
    return getActiveColor(name, value, colors);
  }, [name, value, colors]);
  return createElement(ColorPalette, {
    value: activeColor,
    onChange: onColorChange
  });
};

export default function InlineColorUI(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      onChange = _ref2.onChange,
      onClose = _ref2.onClose,
      contentRef = _ref2.contentRef;
  var anchorRef = useAnchorRef({
    ref: contentRef,
    value: value,
    settings: settings
  });
  return createElement(URLPopover, {
    value: value,
    onClose: onClose,
    className: "components-inline-color-popover",
    anchorRef: anchorRef
  }, createElement(ColorPicker, {
    name: name,
    value: value,
    onChange: onChange
  }));
}
//# sourceMappingURL=inline.js.map